import aboutImage from "../../assets/images/home/abutmodern.png";
import { Box, Grid, Stack, Typography } from "@mui/material";

const About = () => {
  return (
    <Stack
      sx={{
        backgroundColor: "primary.main",
        p: 4,
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
      }}
      direction="column"
      alignItems="center"
      spacing={1}
    >
      <Typography
        variant="h4"
        sx={{
          color: "text.primary",
          fontSize: { xs: "2rem", md: "3rem" },
          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        About Us
      </Typography>
      <Grid
        container
        spacing={4}
        alignItems="center"
        justifyContent="center"
        sx={{ width: "100%", maxWidth: "1200px" }}
      >
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={aboutImage}
              alt="About Us"
              style={{
                maxWidth: "100%",
                height: "auto",
                borderRadius: "8px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              backgroundColor: "primary.main",
              p: { xs: 1, md: 2 },
              width: "90%",
              margin: "auto",
            }}
          >
            <Stack
              direction="column"
              alignItems="flex-start"
              justifyContent="center"
              sx={{ p: { xs: 1, md: 3 } }}
            >
              <Typography
                variant="body1"
                textAlign="justify"
                sx={{
                  color: "text.primary",
                  lineHeight: 1.6,
                  fontSize: { xs: "12px", md: "16px" },
                }}
              >
                Progressive Education Society was established in 1934 by the
                eminent educationist Prof. S. R. Kanitkar and is renowned for
                its academic excellence. This esteemed society successfully
                operates various institutes, ranging from kindergarten to
                postgraduate levels. Prof. Kanitkar was assisted by dedicated
                teachers like Shri V. T. Tatke, Shri G. G. Damle, and Shri
                Koparkar. His leadership and optimism inspired those who worked
                with him to establish a new high school in Pune city, despite
                the challenges of the time. Prof. Kanitkar's strict discipline
                and exemplary teaching methods have set a high standard,
                reflecting the progressive and modern ethos of the society.
              </Typography>
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default About;
